export const ActionTypes = {
  LOADING: "ASSIGN_DECISION_LOADING",
  ERROR: "ASSIGN_DECISION_ERROR",
  SUCCESS: "ASSIGN_DECISION_SUCCESS",
};
